import { API } from "../../constAPI";

const jsonHeaders = {
  Accept: "application/json",
  "Content-type": "application/json",
};

function buildQuery(filters = {}) {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      params.set(key, value);
    }
  });
  const query = params.toString();
  return query ? `?${query}` : "";
}

export const getMarketingSegments = (token) => {
  return fetch(`${API}/api/admin/marketing-segments`, {
    headers: {
      Authorization: `token ${token}`,
      ...jsonHeaders,
    },
  })
    .then((response) => response.json())
    .catch((error) => console.log(error));
};

export const getMarketingSegmentRows = (segment, token, filters = {}) => {
  return fetch(`${API}/api/admin/marketing-segments/${segment}${buildQuery(filters)}`, {
    headers: {
      Authorization: `token ${token}`,
      ...jsonHeaders,
    },
  })
    .then((response) => response.json())
    .catch((error) => console.log(error));
};

export const downloadMarketingSegmentCsv = (segment, token, filters = {}) => {
  return fetch(`${API}/api/admin/marketing-segments/${segment}.csv${buildQuery(filters)}`, {
    headers: {
      Authorization: `token ${token}`,
      Accept: "text/csv",
    },
  });
};
